import React, { ReactNode } from 'react';

import { StepComponentProps } from 'components/Flow/RenderMachine';
import SplashWrapper from 'retired/SplashWrapper';

import { Breadcrumbs } from './Breadcrumbs';
import { ScrollContainer } from './ScrollContainer';

export const Layout = ({
  send,
  children,
  title,
}: {
  send: StepComponentProps['send'];
  children: ReactNode;
  title: string;
}) => (
  <SplashWrapper>
    <ScrollContainer bottom={<Breadcrumbs send={send} title={title} />}>{children}</ScrollContainer>
  </SplashWrapper>
);
